import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 17l0 -14","key":"svg-0"}],["path",{"d":"M15 6l-3 -3l-3 3","key":"svg-1"}],["path",{"d":"M10 21v-4h4v4l-4 0","key":"svg-2"}]]

/**
 * IconArrowUpSquare
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctdXAtc3F1YXJlIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xMiAxN2wwIC0xNCIgLz4KICA8cGF0aCBkPSJNMTUgNmwtMyAtM2wtMyAzIiAvPgogIDxwYXRoIGQ9Ik0xMCAyMXYtNGg0djRsLTQgMCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/arrow-up-square
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowUpSquare = createReactComponent('outline', 'arrow-up-square', 'ArrowUpSquare', __iconNode);

export default IconArrowUpSquare;